import { ClassValue } from 'classnames/types';
import { twMergeCustom } from '@notch-ordering/ui-components';
import cx from 'classnames';

export const mergeClassNames = (...classes: ClassValue[]):string => twMergeCustom(cx(...classes));
